import { render, staticRenderFns } from "./FieldPreviewQuestion.vue?vue&type=template&id=142fa3ac&scoped=true"
import script from "./FieldPreviewQuestion.vue?vue&type=script&lang=js"
export * from "./FieldPreviewQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142fa3ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('142fa3ac')) {
      api.createRecord('142fa3ac', component.options)
    } else {
      api.reload('142fa3ac', component.options)
    }
    module.hot.accept("./FieldPreviewQuestion.vue?vue&type=template&id=142fa3ac&scoped=true", function () {
      api.rerender('142fa3ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldPreviewQuestion.vue"
export default component.exports